// List keys that cannot collide. Statements, events and legend rows are keyed by their own text,
// and real data repeats: one speaker can make two statements on a day. A repeated key makes
// Preact reuse the wrong DOM node, so repeats get a "#n" suffix.

const REPEAT_SEP = '#';
const QUOTE_HEAD_CHARS = 24;

/** What tells one statement from another: who said it, when, and how it starts. */
export function statementBase(s: { actor: string; date: string; speaker: string; quote: string }): string {
  return s.actor + s.date + s.speaker + s.quote.slice(0, QUOTE_HEAD_CHARS);
}

/** One key per base, in order: the first use of a base is unchanged, later uses gain a suffix. */
export function uniqueKeys(bases: readonly string[]): string[] {
  const taken = new Set<string>();
  const uses = new Map<string, number>();

  return bases.map((base) => {
    let n = uses.get(base) ?? 0;
    let key = n === 0 ? base : `${base}${REPEAT_SEP}${n}`;

    // A suffixed key may equal a real base further down the list.
    while (taken.has(key)) {
      n += 1;
      key = `${base}${REPEAT_SEP}${n}`;
    }

    uses.set(base, n + 1);
    taken.add(key);
    return key;
  });
}
